import {ProtocolQuery} from '../../../service-model/protocol-query.interface';
import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-protocol-namespace.const';

/**
 * @returns HpDatasetDto[]
 */
export class GetHpDatasets implements ProtocolQuery {
  constructor(public strategyId: string) {
  }

  getOperationName(): string {
    return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetHpDatasets`;
  }
}